import { InjectionToken, Type } from '@angular/core';

export const NODE_DETAIL_POPOVER_REFERENCES_DATA = new InjectionToken<Type<unknown>>('NODE_DETAIL_POPOVER_REFERENCES_DATA');
